__turbopack_context__.v({
  "eyebrow": "DigitalFulfilmentServicesCardSection-module__uiFbGq__eyebrow",
  "heading": "DigitalFulfilmentServicesCardSection-module__uiFbGq__heading",
  "section": "DigitalFulfilmentServicesCardSection-module__uiFbGq__section",
  "title": "DigitalFulfilmentServicesCardSection-module__uiFbGq__title",
});
